import {
  AppNotificationGroupViewDto,
  AppNotificationViewDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const appNotificationRequests = {
  getAppNotificationGroupTypes: EndpointDefinition.get<
    AppNotificationGroupViewDto,
    null
  >({
    name: 'getAppNotificationGroupTypes',
    route: '/notifications/groups',
  }),

  getAppNotificationsForGuide: EndpointDefinition.get<
    AppNotificationViewDto,
    null
  >({
    name: 'getAppNotificationsForGuide',
    route: '/notifications/guide',
  }),

  markAppNotificationsAsSeen: EndpointDefinition.patch<
    null,
    {
      notificationIds: number[];
      seen: boolean;
    },
    null
  >({
    name: 'markAppNotificationsAsSeen',
    route: '/notifications/seen',
  }),

  deleteAppNotifications: EndpointDefinition.delete<
    null,
    { notificationIds: number[] }
  >({
    name: 'deleteAppNotifications',
    route: '/notifications',
  }),
};
